<template>
  <div
    class="upsi-status-cell"
    :class="{ 'upsi-status-cell--hovered': rowHovered }"
    :data-testid="`cycles-page__upsi-status--${index}`"
  >
    <span class="upsi-status-cell__label">{{ stageLabel }}</span>
    <span class="upsi-status-cell__info-wrap">
      <FcTooltip
        :text="viewDetailsTooltip"
        placement="bottom"
        fixed
        eager
        transition="fade-transition"
        :open-delay="0"
        content-class="upsi-status-cell__tooltip"
      >
        <button
          type="button"
          class="upsi-status-cell__info"
          :aria-label="viewDetailsTooltip"
          :data-testid="`cycles-page__upsi-info-btn--${index}`"
          @click.stop="onViewDetails"
        >
          <v-icon class="upsi-status-cell__info-icon" aria-hidden="true">mdi-information-outline</v-icon>
        </button>
      </FcTooltip>
    </span>
  </div>
</template>

<script>
import './UpsiStatusCell.scss';
import { FcTooltip } from '@/modules/financialclose/components';
import { UPSI_TOOLTIPS } from '../../../../utils/constants';
import { upsiStageLabel } from './upsiDialogUtils';

/** UPSI stage label plus a hover/focus control that opens request details. */
export default {
  name: 'UpsiStatusCell',

  components: {
    FcTooltip,
  },

  props: {
    upsiState: {
      type: Object,
      default: () => ({}),
    },
    rowHovered: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    stageLabel() {
      const stage = this.upsiState ? this.upsiState.stage : 0;
      return upsiStageLabel(stage);
    },
    viewDetailsTooltip() {
      return UPSI_TOOLTIPS.VIEW_DETAILS;
    },
  },

  methods: {
    onViewDetails() {
      console.log('[UpsiStatusCell]:', { index: this.index, stage: this.upsiState && this.upsiState.stage });
      this.$emit('view-details');
    },
  },
};
</script>
